export const config = {
  appname: 'crmplusconsumer',
  client_id: '1034965643374287', // App ID
  debug: false, //enable console.log
  bzbsAnalyticId: 275,
  env: 'prd',

  // ------------- Business Rule ----------------
  businessRule: {
    webFor: {
      TH: true, //Thailand
      PH: false, //Philippines
    },
    max: {
      photoSize: 3,
      phoneLength: 10,
      citizenIdLength: 13,
    },
    config: {
      Azure: true,
      Facebook: false,
    },
  },

  //------------- Production Settings ----------------
  agency_id: '',
  bzbUrlService: 'https://api20service-2.buzzebees.com',
  bzbModuleUrl: 'https://buzzcrmplusmodule.buzzebees.com',
  bzbBlobUrl: 'https://cdn.buzzebees.com/th',
  bzbEwalletUrl: 'https://api1servicewallet.buzzebees.com',
  bzbsAnalyticUrl: 'https://analytics-api-02.buzzebees.com/api/gate',
  bzbsGiftCardWalletUrl: 'https://giftcardwalletmodule.buzzebees.com',
  bzbsBeeRewardUrl: 'https://apibew.buzzebees.com',
  bzbsBeeRewardDirectUrl: 'https://bshop.buzzebees.com',
  bzbsBpsPosUrl: 'https://apibpapos.buzzebees.com',
  bzbsCashcardUrl: 'https://cashcardwalletmodule.buzzebees.com',
}
